import axios from 'axios'
import { CONST_HEADER } from '@/api/config/default'

export function exportAxios (url, params, type) {
  if (type === 'get') {
    return axios.create({
      headers: {
        'Content-Type': 'application/json',
        ...CONST_HEADER(),
      },
      responseType: 'blob',
    }).get(url, params)
  }
  return axios.create({
    headers: {
      'Content-Type': 'application/json',
      ...CONST_HEADER(),
    },
    responseType: 'blob',
  }).post(url, params)
}

export function storageAxios (url, params, type) {
  return axios.create({
    // baseURL: 'https://some-domain.com/api/',
  }).post(url, params)
}
